

import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllBudgetReportCount = createAsyncThunk(
    'report/fetchAllExpensesReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/budget/count`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all budget Report');
        }
    }
);
export const fetchAllBudgetReportCountMonthly = createAsyncThunk(
    'report/fetchAllExpensesReport',
    async ( year : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/budget/count/monthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all budget Report');
        }
    }
);
